import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Tên hàng hóa", -1)
const _hoisted_4 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_6 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Chiết khấu(%)", -1)
const _hoisted_8 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_10 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_12 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền", -1)
const _hoisted_14 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian nhập", -1)
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê: ", -1)
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_20 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_21 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_23 = { class: "p-fluid" }
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_25 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Tên hàng hóa", -1)
const _hoisted_28 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_30 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Chiết khấu(%)", -1)
const _hoisted_32 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_34 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_36 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền", -1)
const _hoisted_38 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian nhập", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Thêm hàng hóa mới" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              id: "tenHangHoa",
              type: "text",
              modelValue: $setup.nhapHangHoaCreate.tenHangHoa,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.nhapHangHoaCreate.tenHangHoa) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputNumber, {
              id: "giaBan",
              type: "text",
              modelValue: $setup.nhapHangHoaCreate.giaBan,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.nhapHangHoaCreate.giaBan) = $event)),
                $setup.giaNhap
              ],
              inputId: "integeronly"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputNumber, {
              id: "chietKhau",
              type: "text",
              modelValue: $setup.nhapHangHoaCreate.chietKhau,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => (($setup.nhapHangHoaCreate.chietKhau) = $event)),
                $setup.giaNhap
              ],
              inputId: "integeronly"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputNumber, {
              id: "giaNhap",
              type: "text",
              modelValue: $setup.nhapHangHoaCreate.giaNhap,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => (($setup.nhapHangHoaCreate.giaNhap) = $event)),
                $setup.tinhTienCreate
              ],
              inputId: "integeronly"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputNumber, {
              id: "soLuong",
              type: "text",
              modelValue: $setup.nhapHangHoaCreate.soLuong,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => (($setup.nhapHangHoaCreate.soLuong) = $event)),
                $setup.tinhTienCreate
              ],
              inputId: "integeronly"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_InputNumber, {
              id: "tongTien",
              type: "text",
              modelValue: $setup.nhapHangHoaCreate.tongTien,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.nhapHangHoaCreate.tongTien) = $event)),
              inputId: "integeronly",
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: $setup.dateMuaHang,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.dateMuaHang) = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "1930:2100"
            }, null, 8, ["modelValue"])
          ])
        ]),
        ($setup.validHangHoa)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-spa-add",
              label: "Thêm",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.createHangHoa()))
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: "Thêm",
              class: "btn-spa-add",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              disabled: "disabled"
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Danh sách hàng hóa" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.date) = $event)),
              selectionMode: "range",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100",
              onDateSelect: _cache[9] || (_cache[9] = ($event: any) => ($setup.getListHangHoa())),
              onClearClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.clearCalendar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_DataTable, {
              value: $setup.listNhapHangHoaDetail,
              showGridlines: true,
              paginator: true,
              stripedRows: "",
              rows: 10,
              rowsPerPageOptions: [10,25,50],
              rowHover: true,
              filters: $setup.filters,
              "onUpdate:filters": _cache[13] || (_cache[13] = ($event: any) => (($setup.filters) = $event)),
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              globalFilterFields: ['tenHangHoa'],
              currentPageReportTemplate: "Có tổng số {totalRecords} hàng hóa",
              columnResizeMode: "expand"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-filter-slash",
                    label: "Xoá",
                    class: "p-button-outlined",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.clearFilter())),
                    style: {"width":"100px","margin-right":"10px"}
                  }),
                  _createElementVNode("span", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_InputText, {
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      placeholder: "Tìm theo tên sản phẩm"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  header: "Stt",
                  headerStyle: "width:3rem"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "tenHangHoa",
                  header: "Tên hàng hóa",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "giaBan",
                  header: "Giá bán",
                  style: {"font-weight":"bold","color":"rgb(239 34 146)"},
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "chietKhau",
                  header: "Chiết khấu",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "giaNhap",
                  header: "Giá nhập",
                  style: {"font-weight":"bold","color":"red"},
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaNhap)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "soLuong",
                  header: "Số lượng",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "tongTien",
                  header: "Tổng tiền",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.tongTien)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "thoiGianMuaHang",
                  dataType: "date",
                  header: "Thời gian mua",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianMuaHang)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "nguoiTao",
                  header: "Người tạo",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "thoiGianTao",
                  dataType: "date",
                  header: "Thời gian tạo",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianTao)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "nguoiCapNhat",
                  header: "Người cập nhật",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "thoiGianCapNhat",
                  dataType: "date",
                  header: "Thời gian cập nhật",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  dataType: "date",
                  header: "Tùy chọn",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Button, {
                      style: {"max-width":"200px"},
                      class: "btn-spa-update",
                      label: "Cập nhật",
                      severity: "warning",
                      icon: "pi pi-sync",
                      iconPos: "left",
                      onClick: ($event: any) => ($setup.selectHangHoa(data.id))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "filters"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Dialog, {
          visible: $setup.showUpdate,
          "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => (($setup.showUpdate) = $event)),
          modal: "",
          blockScroll: "",
          style: { width: '70vw'},
          breakpoints: { '1500px': '50vw', '1150px': '60vw', '800px': '90vw' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Cập nhật hàng hóa" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_InputText, {
                      id: "tenHangHoaUpdate",
                      type: "text",
                      modelValue: $setup.nhapHangHoaUpdate.tenHangHoa,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.nhapHangHoaUpdate.tenHangHoa) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_InputNumber, {
                      id: "giaBanUpdate",
                      type: "text",
                      modelValue: $setup.nhapHangHoaUpdate.giaBan,
                      "onUpdate:modelValue": [
                        _cache[15] || (_cache[15] = ($event: any) => (($setup.nhapHangHoaUpdate.giaBan) = $event)),
                        $setup.giaNhapUpdate
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_InputNumber, {
                      id: "chietKhauUpdate",
                      type: "text",
                      modelValue: $setup.nhapHangHoaUpdate.chietKhau,
                      "onUpdate:modelValue": [
                        _cache[16] || (_cache[16] = ($event: any) => (($setup.nhapHangHoaUpdate.chietKhau) = $event)),
                        $setup.giaNhapUpdate
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_InputNumber, {
                      id: "giaNhapUpdate",
                      type: "text",
                      modelValue: $setup.nhapHangHoaUpdate.giaNhap,
                      "onUpdate:modelValue": [
                        _cache[17] || (_cache[17] = ($event: any) => (($setup.nhapHangHoaUpdate.giaNhap) = $event)),
                        $setup.tinhTienUpdate
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_InputNumber, {
                      id: "soLuongUpdate",
                      type: "text",
                      modelValue: $setup.nhapHangHoaUpdate.soLuong,
                      "onUpdate:modelValue": [
                        _cache[18] || (_cache[18] = ($event: any) => (($setup.nhapHangHoaUpdate.soLuong) = $event)),
                        $setup.tinhTienUpdate
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_InputNumber, {
                      id: "tongTienUpdate",
                      type: "text",
                      modelValue: $setup.nhapHangHoaUpdate.tongTien,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.nhapHangHoaUpdate.tongTien) = $event)),
                      inputId: "integeronly",
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.dateMuaHangUpdate,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.dateMuaHangUpdate) = $event)),
                      selectionMode: "single",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "1930:2100"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.validHangHoaUpdate)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "Cập nhật",
                      class: "btn-spa-update",
                      icon: "pi pi-sync",
                      iconPos: "left",
                      severity: "warning",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.updateHangHoa()))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Cập nhật",
                      class: "btn-spa-update",
                      icon: "pi pi-sync",
                      iconPos: "left",
                      disabled: "disabled"
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ])
  ], 64))
}